module.exports = __webpack_public_path__ + "img/Metatext_banner2x_.0cf33611.jpg";